import { Suspense } from "react";
import {
  MutationCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { errorMessage } from "./api/apiError";
import { emitApiError } from "./api/apiErrorStore";
import { NotificationCenter } from "./components/NotificationCenter";
import { AuthProvider } from "./features/auth/AuthProvider";
import { router } from "./routes";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
  // Surface every failed mutation (create/update/delete actions) in the global error banner.
  mutationCache: new MutationCache({
    onError: (error) => emitApiError(errorMessage(error)),
  }),
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Suspense fallback={null}>
          <RouterProvider router={router} />
        </Suspense>
      </AuthProvider>
      <NotificationCenter />
    </QueryClientProvider>
  );
}

export default App;
